export default __webpack_public_path__ + "static/media/metaqualt-logo1.b154cbac.webp";